(function () {
  if (window.__chegouInit) return;
  window.__chegouInit = true;
  var root = document.documentElement;
  if (!('IntersectionObserver' in window)) return;
  root.classList.add('cp-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(scope) {
    (scope || document).querySelectorAll('.cp-reveal:not(.is-visible)').forEach(function (el) { io.observe(el); });
  }
  scan();
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    e.target.querySelectorAll('.cp-reveal').forEach(function (el) { el.classList.add('is-visible'); });
  });
  // Segurança: nada fica invisível se algo falhar
  setTimeout(function () { document.querySelectorAll('.cp-reveal').forEach(function (el) { el.classList.add('is-visible'); }); }, 4000);
})();
